import { Action } from "../types"
import { UserAction } from "./actions"
import { UserState } from "./types"

const initial_user: UserState = {
  name: '',
  username: '',
  first_name: '',
  last_name: '',
  id: '',
  initialized: false,
  access_token: undefined,
  refresh_token: undefined,
  language: 'is',
  main_fleet: undefined,
  email: undefined,
  groups: [],
  permissions: {
    trackwell: {},
    auth: {},
    fleet: {},
  },
  available_fleets: [],
  preferences: undefined
}

const userReducer = (state = initial_user, action: Action): UserState => {
  const { data, type } = action ?? {}
  switch (type) {
    case UserAction.SET_INITIALIZATION:
      return {
        ...state,
        initialized: data
      }
      break

    case UserAction.SET_TOKENS:
      return {
        ...state,
        access_token: data.access,
        refresh_token: data.refresh
      }
      break

    case UserAction.SET_ACCESS_TOKEN:
      return {
        ...state,
        access_token: data,
      }
      break

    case UserAction.SET_USER:
      return {
        ...state,
        ...data
      }
      break

    case UserAction.LOG_OUT_USER:
      return {
        ...initial_user,
        initialized: true
      }
      break

    case UserAction.SET_LANGUAGE:
      return {
        ...state,
        language: data
      }
      break

    default:
      return state
  }
}

export { userReducer, initial_user }
